<template>
  <div>
    <InvoiceItemsSection v-if="flattened" :items="items" :title="flatTitle" />
    <InvoiceItemsSection
      v-else
      :items="line_items"
      :title="sectionName"
      v-for="(line_items, sectionName) of itemsBySection"
      :key="sectionName"
    />
  </div>
</template>

<script>
import InvoiceItemsSection from '@/components/InvoiceItemsSection'
import _get from 'lodash/get'
import _groupBy from 'lodash/groupBy'
import _isNull from 'lodash/isNull'
export default {
  name: 'InvoiceLineItems',
  components: { InvoiceItemsSection },
  props: {
    items: {
      type: Array,
      require: true,
      default: () => [],
    },
    // Flag to display the items as "flat" or uncategorized
    flattened: {
      type: Boolean,
      default: false,
    },
    flatTitle: {
      type: String,
      default: 'Order Items',
    },
  },
  data() {
    return {}
  },
  computed: {
    itemsBySection() {
      return _groupBy(this.items, (item) => {
        const sectionName = _get(item, 'section_name', 'Uncategorized')
        return _isNull(sectionName) ? 'Uncategorized' : sectionName
      })
    }, // itemsBySection
  },
}
</script>
